export default __webpack_public_path__ + "static/media/Clinic-icon.70874fa7.png";